"use client";

import React, { useEffect } from "react";
import { usePathname } from "next/navigation";
import { rum } from "@/lib/telemetry/rum";

export function TelemetryProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    rum.init();
  }, []);

  useEffect(() => {
    if (pathname) {
      rum.trackPageView(pathname);
    }
  }, [pathname]);

  return <>{children}</>;
}
